/* ── ARTORA THEME JS ── */
document.addEventListener('DOMContentLoaded', function () {

  /* ── STICKY HEADER ── */
  var header = document.querySelector('.main-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── HAMBURGER / MOBILE MENU ── */
  var hamburger  = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('open');
      hamburger.classList.toggle('open', isOpen);
      hamburger.setAttribute('aria-expanded', String(isOpen));
      mobileMenu.setAttribute('aria-hidden', String(!isOpen));
    });
  }

  /* ── SEARCH BAR (slides inside header) ── */
  var searchToggle  = document.getElementById('search-toggle');
  var searchBar     = document.getElementById('header-search-bar');
  var searchCloseBtn= document.getElementById('search-close-btn');
  var searchInput   = document.getElementById('header-search-input');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function() {
      var isOpen = searchBar.classList.toggle('open');
      searchBar.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen && searchInput) setTimeout(function() { searchInput.focus(); }, 50);
    });
  }
  if (searchCloseBtn && searchBar) {
    searchCloseBtn.addEventListener('click', function() {
      searchBar.classList.remove('open');
      searchBar.setAttribute('aria-hidden', 'true');
    });
  }
  /* ── MEGA MENU: close on outside click / Escape ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchDrawer) searchDrawer.classList.remove('open');
    }
  });

  /* ── PREMIUM TABS ── */
  document.querySelectorAll('[data-tabs]').forEach(function (bar) {
    bar.querySelectorAll('.tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        bar.querySelectorAll('.tab').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  });

  /* ── TRENDING TABS ── */
  var trendBar = document.getElementById('trend-bar');
  if (trendBar) {
    trendBar.querySelectorAll('.trending-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        trendBar.querySelectorAll('.trending-tab').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  /* ── SCROLL REVEAL ── */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function (el) { revealObserver.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── CART COUNT UPDATE ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.querySelector('.cart-count');
        if (count) count.textContent = cart.item_count;
      })
      .catch(function () {});
  }
  updateCartCount();

  /* ── MEGA MENU POSITION (recalc on resize) ── */
  function setMegaTop() {
    var hdr = document.querySelector('.main-header');
    if (!hdr) return;
    var top = hdr.offsetTop + hdr.offsetHeight;
    document.querySelectorAll('.mega-menu, .search-drawer').forEach(function (el) {
      el.style.top = top + 'px';
    });
  }
  setMegaTop();
  window.addEventListener('resize', setMegaTop, { passive: true });
  window.addEventListener('scroll', setMegaTop, { passive: true });

  /* ── CART DRAWER ── */
  var cartDrawer        = document.getElementById('cart-drawer');
  var cartDrawerToggle  = document.getElementById('cart-drawer-toggle');
  var cartDrawerClose   = document.getElementById('cart-drawer-close');
  var cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  var cartDrawerItems   = document.getElementById('cart-drawer-items');
  var cartDrawerSubtotal = document.getElementById('cart-drawer-subtotal');
  var cartDrawerCount   = document.getElementById('cart-drawer-count');
  var cartCountBadge    = document.getElementById('cart-count-badge');

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '\u20b9' + Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 2 });
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCartDrawer() {
    if (!cartDrawerItems) return;
    cartDrawerItems.innerHTML = '<div class="cart-drawer-loading">Loading\u2026</div>';
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Update badges
        if (cartCountBadge) cartCountBadge.textContent = cart.item_count;
        if (cartDrawerCount) cartDrawerCount.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);

        if (cart.item_count === 0) {
          cartDrawerItems.innerHTML =
            '<div class="cart-drawer-empty">' +
              '<p>Your cart is empty</p>' +
              '<span>Add some beautiful pieces to get started</span>' +
            '</div>';
          return;
        }

        var html = '';
        cart.items.forEach(function(item) {
          var imgHtml = item.image
            ? '<img class="cart-item-img" src="' + item.image + '" alt="' + item.product_title + '">'
            : '<div class="cart-item-img-placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1" width="32" height="32"><rect x="3" y="3" width="18" height="18" rx="1"/><path d="M3 9l4-4 4 4 4-5 4 5"/></svg></div>';

          var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<p class="cart-item-variant">' + item.variant_title + '</p>'
            : '';

          html +=
            '<div class="cart-item" data-key="' + item.key + '">' +
              '<a href="' + item.url + '">' + imgHtml + '</a>' +
              '<div class="cart-item-info">' +
                '<a href="' + item.url + '" class="cart-item-title">' + item.product_title + '</a>' +
                variantHtml +
                '<div class="cart-item-price-row">' +
                  '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
                  '<div class="cart-item-qty">' +
                    '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="Decrease">&#8722;</button>' +
                    '<span class="cart-item-qty-val">' + item.quantity + '</span>' +
                    '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="Increase">+</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<button class="cart-item-remove" data-key="' + item.key + '" aria-label="Remove item">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
              '</button>' +
            '</div>';
        });

        cartDrawerItems.innerHTML = html;
        attachCartItemEvents();
      })
      .catch(function() {
        cartDrawerItems.innerHTML = '<div class="cart-drawer-loading">Could not load cart.</div>';
      });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() { renderCartDrawer(); })
    .catch(function() {});
  }

  function attachCartItemEvents() {
    // Qty buttons
    cartDrawerItems.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key   = btn.getAttribute('data-key');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var row   = btn.closest('.cart-item');
        var current = parseInt(row.querySelector('.cart-item-qty-val').textContent, 10);
        updateCartItem(key, Math.max(0, current + delta));
      });
    });
    // Remove buttons
    cartDrawerItems.querySelectorAll('.cart-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.getAttribute('data-key'), 0);
      });
    });
  }

  if (cartDrawerToggle) {
    cartDrawerToggle.addEventListener('click', openCartDrawer);
  }
  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) {
      closeCartDrawer();
    }
  });


/* ── FEATURED COLLECTION — TABS + SLIDER ── */
  document.querySelectorAll('.fc-tab-bar').forEach(function(bar) {
    var sectionEl = bar.closest('.fc-section');
    if (!sectionEl) return;
    var panels = sectionEl.querySelectorAll('.fc-panel');

    bar.querySelectorAll('.fc-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var idx = parseInt(tab.getAttribute('data-tab'), 10);
        bar.querySelectorAll('.fc-tab').forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        panels.forEach(function(p, i) {
          p.classList.toggle('active', i === idx);
        });
        // reset slider on switch
        var panel = panels[idx];
        if (panel) {
          var track = panel.querySelector('.fc-slider-track');
          if (track) { track.style.transform = 'translateX(0)'; }
        }
      });
    });
  });

  /* ── SLIDER LOGIC — init each fc-panel ── */
  function initSlider(panel) {
    var track    = panel.querySelector('.fc-slider-track');
    var viewport = panel.querySelector('.fc-slider-viewport');
    var dotsEl   = panel.querySelector('.fc-dots');
    var prevBtn  = panel.querySelector('.fc-prev');
    var nextBtn  = panel.querySelector('.fc-next');
    if (!track) return;

    var slides   = Array.from(track.querySelectorAll('.fc-slide'));
    var current  = 0;

    function getPerView() {
      if (window.innerWidth < 768)  return 2;
      if (window.innerWidth < 1024) return 3;
      return 4;
    }

    function getSlideWidth() {
      return viewport.offsetWidth / getPerView();
    }

    function maxIndex() {
      return Math.max(0, slides.length - getPerView());
    }

    function renderDots() {
      if (!dotsEl) return;
      var pages = maxIndex() + 1;
      dotsEl.innerHTML = '';
      for (var i = 0; i <= maxIndex(); i++) {
        var dot = document.createElement('button');
        dot.className = 'fc-dot' + (i === current ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function(idx) {
          dot.addEventListener('click', function() { goTo(idx); });
        })(i);
        dotsEl.appendChild(dot);
      }
    }

    function goTo(n) {
      current = Math.max(0, Math.min(n, maxIndex()));
      var w = getSlideWidth();
      track.style.transform = 'translateX(-' + (current * w) + 'px)';
      renderDots();
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    renderDots();
    window.addEventListener('resize', function() { goTo(current); }, { passive: true });
  }

  document.querySelectorAll('.fc-panel').forEach(function(panel) {
    initSlider(panel);
  });

  /* ── QUICK ADD TO CART from product cards ── */
  /* ── TOAST NOTIFICATION ── */
  function showToast(msg, type) {
    var existing = document.getElementById('artora-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'artora-toast';
    toast.className = 'artora-toast artora-toast--' + (type || 'success');
    toast.innerHTML =
      '<span class="artora-toast-icon">' +
        (type === 'error'
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg>') +
      '</span>' +
      '<span class="artora-toast-msg">' + msg + '</span>';
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { toast.classList.add('show'); });
    });
    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 400);
    }, 3000);
  }

  /* ── RIPPLE EFFECT ── */
  function createRipple(btn) {
    var r = document.createElement('span');
    r.className = 'btn-ripple';
    var rect = btn.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height) * 1.5;
    r.style.cssText = 'width:' + size + 'px;height:' + size + 'px;top:50%;left:50%;transform:translate(-50%,-50%) scale(0);';
    btn.style.position = 'relative';
    btn.style.overflow = 'hidden';
    btn.appendChild(r);
    requestAnimationFrame(function() {
      r.style.transform = 'translate(-50%,-50%) scale(1)';
      r.style.opacity = '0';
    });
    setTimeout(function() { r.remove(); }, 600);
  }

  /* ── QUICK ADD TO CART ── */
  function quickAddToCart(variantId, btnEl, productTitle) {
    if (!variantId) return;
    var origHtml = btnEl.innerHTML;
    createRipple(btnEl);
    btnEl.innerHTML =
      '<svg class="spin-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">' +
        '<path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/>' +
      '</svg>';
    btnEl.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function() {
      btnEl.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg>';
      showToast((productTitle || 'Item') + ' added to cart');
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      var badge = document.getElementById('cart-count-badge');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.classList.add('bounce');
        setTimeout(function() { badge.classList.remove('bounce'); }, 500);
      }
      setTimeout(function() { btnEl.innerHTML = origHtml; btnEl.disabled = false; }, 1600);
    })
    .catch(function() {
      btnEl.innerHTML = origHtml;
      btnEl.disabled = false;
      showToast('Could not add to cart. Please try again.', 'error');
    });
  }

  /* ── QUICKSHOP MODAL ── */
  var qsModal    = document.getElementById('quickshop-modal');
  var qsOverlay  = document.getElementById('qs-overlay');
  var qsClose    = document.getElementById('qs-close');
  var qsBody     = document.getElementById('qs-body');

  function openQuickshop(handle) {
    if (!qsModal || !qsBody) return;
    qsModal.classList.add('open');
    qsModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    qsBody.innerHTML =
      '<div class="qs-skeleton">' +
        '<div class="qs-skel-img"></div>' +
        '<div class="qs-skel-info">' +
          '<div class="skel-line skel-line--sm"></div>' +
          '<div class="skel-line skel-line--lg"></div>' +
          '<div class="skel-line skel-line--lg" style="width:70%"></div>' +
          '<div class="skel-line skel-line--sm" style="width:40%"></div>' +
          '<div class="skel-line" style="width:55%;margin-top:8px"></div>' +
          '<div style="display:flex;gap:8px;margin-top:24px">' +
            '<div class="skel-line" style="width:100px;height:44px"></div>' +
            '<div class="skel-line" style="flex:1;height:44px"></div>' +
          '</div>' +
        '</div>' +
      '</div>';

    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var p = data.product;
        var firstVariant = p.variants[0];
        var imgs = p.images || [];

        // Build images HTML
        var imgHtml = '';
        if (imgs.length > 0) {
          imgHtml = '<img class="qs-img-main" id="qs-main-img" src="' + imgs[0].src + '" alt="' + (p.title || '') + '">';
          if (imgs.length > 1) {
            imgHtml += '<div class="qs-img-thumbs">';
            imgs.forEach(function(img, i) {
              imgHtml += '<button class="qs-img-dot' + (i === 0 ? ' active' : '') + '" data-src="' + img.src + '" aria-label="Image ' + (i+1) + '"></button>';
            });
            imgHtml += '</div>';
          }
        } else {
          imgHtml = '<div style="width:100%;aspect-ratio:1/1;background:var(--light);min-height:380px;"></div>';
        }

        // Build variants/options HTML
        var optHtml = '';
        if (p.options && p.options.length === 1 && p.options[0].name === 'Title' && p.options[0].values[0] === 'Default Title') {
          // single default variant
        } else if (p.options) {
          p.options.forEach(function(opt, oi) {
            optHtml += '<p class="qs-option-label">' + opt.name + '</p><div class="qs-option-btns">';
            opt.values.forEach(function(val, vi) {
              optHtml += '<button class="qs-opt-btn' + (vi === 0 ? ' selected' : '') + '" data-opt-index="' + oi + '" data-opt-value="' + val + '">' + val + '</button>';
            });
            optHtml += '</div>';
          });
        }

        // Price
        var price = (parseInt(firstVariant.price) / 1).toFixed(2);
        var comparePrice = firstVariant.compare_at_price ? (parseInt(firstVariant.compare_at_price) / 1).toFixed(2) : null;
        var priceHtml = '<span class="qs-price-sale">\u20b9' + Number(price).toLocaleString('en-IN', {minimumFractionDigits: 2}) + '</span>';
        if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
          priceHtml += '<span class="qs-price-compare">\u20b9' + Number(comparePrice).toLocaleString('en-IN', {minimumFractionDigits: 2}) + '</span>';
        }

        var descShort = p.body_html ? p.body_html.replace(/<[^>]+>/g, '').substring(0, 160) + '\u2026' : '';

        qsBody.innerHTML =
          '<div class="qs-inner">' +
            '<div class="qs-imgs">' + imgHtml + '</div>' +
            '<div class="qs-details">' +
              (p.vendor ? '<p class="qs-vendor">' + p.vendor + '</p>' : '') +
              '<h2 class="qs-title">' + p.title + '</h2>' +
              '<div class="qs-price">' + priceHtml + '</div>' +
              (descShort ? '<p class="qs-desc">' + descShort + '</p>' : '') +
              optHtml +
              '<div class="qs-qty-atc">' +
                '<div class="qs-qty">' +
                  '<button type="button" id="qs-qty-minus">&#8722;</button>' +
                  '<input type="number" id="qs-qty" value="1" min="1">' +
                  '<button type="button" id="qs-qty-plus">+</button>' +
                '</div>' +
                '<button type="button" class="qs-atc" id="qs-atc-btn" data-variant-id="' + firstVariant.id + '">ADD TO CART</button>' +
              '</div>' +
              '<div class="qs-meta">' +
                (p.product_type ? '<p><span>TYPE:</span> ' + p.product_type.toUpperCase() + '</p>' : '') +
                (p.vendor 
                  ? '<a href="/collections/vendors?q=' + encodeURIComponent(p.vendor) + '">' +
                      '<p><span>Artist:</span> <span class="artist-name">' + p.vendor.toUpperCase() + '</span></p>' +
                    '</a>' 
                  : '') +

                (firstVariant.sku ? '<p><span>SKU:</span> ' + firstVariant.sku.toUpperCase() + '</p>' : '') +
              '</div>' +
            '</div>' +
          '</div>';


        // Bind image dots
        qsBody.querySelectorAll('.qs-img-dot').forEach(function(dot) {
          dot.addEventListener('click', function() {
            var mainImg = document.getElementById('qs-main-img');
            if (mainImg) mainImg.src = dot.getAttribute('data-src');
            qsBody.querySelectorAll('.qs-img-dot').forEach(function(d) { d.classList.remove('active'); });
            dot.classList.add('active');
          });
        });

        // Bind qty
        var qtyInput = document.getElementById('qs-qty');
        document.getElementById('qs-qty-minus') && document.getElementById('qs-qty-minus').addEventListener('click', function() {
          if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
        });
        document.getElementById('qs-qty-plus') && document.getElementById('qs-qty-plus').addEventListener('click', function() {
          if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
        });

        // Bind options — update selected variant id
        var selectedOptions = p.options ? p.options.map(function(opt) { return opt.values[0]; }) : [];
        function updateVariant() {
          var match = p.variants.find(function(v) {
            return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
          });
          if (match) {
            var atcBtn = document.getElementById('qs-atc-btn');
            if (atcBtn) atcBtn.setAttribute('data-variant-id', match.id);
          }
        }
        qsBody.querySelectorAll('.qs-opt-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var oi = parseInt(btn.getAttribute('data-opt-index'), 10);
            var val = btn.getAttribute('data-opt-value');
            selectedOptions[oi] = val;
            qsBody.querySelectorAll('.qs-opt-btn[data-opt-index="' + oi + '"]').forEach(function(b) { b.classList.remove('selected'); });
            btn.classList.add('selected');
            updateVariant();
          });
        });

        // Bind ATC
        var atcBtn = document.getElementById('qs-atc-btn');
        if (atcBtn) {
          atcBtn.addEventListener('click', function() {
            var vid = atcBtn.getAttribute('data-variant-id');
            var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
            createRipple(atcBtn);
            atcBtn.disabled = true;
            atcBtn.innerHTML =
              '<svg class="spin-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">' +
                '<path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/>' +
              '</svg> Adding\u2026';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: qty })
            })
            .then(function(r) { if(!r.ok) throw new Error(); return r.json(); })
            .then(function(item) {
              atcBtn.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="15" height="15"><polyline points="20 6 9 17 4 12"/></svg> Added!';
              showToast((item.title || 'Item') + ' added to cart');
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              var badge = document.getElementById('cart-count-badge');
              if (badge) {
                badge.textContent = cart.item_count;
                badge.classList.add('bounce');
                setTimeout(function() { badge.classList.remove('bounce'); }, 500);
              }
              setTimeout(function() {
                atcBtn.innerHTML = 'ADD TO CART';
                atcBtn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              atcBtn.innerHTML = 'ADD TO CART';
              atcBtn.disabled = false;
              showToast('Could not add to cart.', 'error');
            });
          });
        }
      })
      .catch(function() {
        qsBody.innerHTML = '<div class="qs-loading">Could not load product.</div>';
      });
  }

  function closeQuickshop() {
    if (!qsModal) return;
    qsModal.classList.remove('open');
    qsModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (qsOverlay) qsOverlay.addEventListener('click', closeQuickshop);
  if (qsClose)   qsClose.addEventListener('click',   closeQuickshop);

  // Delegate clicks on .prod-view-btn and .prod-cart-btn globally
  document.addEventListener('click', function(e) {
    var viewBtn = e.target.closest('.prod-view-btn');
    var cartBtn = e.target.closest('.prod-cart-btn');

    if (viewBtn) {
      e.preventDefault();
      var handle = viewBtn.getAttribute('data-product-handle');
      if (handle) openQuickshop(handle);
    }

    if (cartBtn) {
      e.preventDefault();
      var vid = cartBtn.getAttribute('data-variant-id');
      var ptitle = cartBtn.getAttribute('data-product-title') || '';
      quickAddToCart(vid, cartBtn, ptitle);
    }
  });

  // Escape closes quickshop
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && qsModal && qsModal.classList.contains('open')) closeQuickshop();
  });

  /* ── CURRENCY DROPDOWN ── */
  var currencyBtn = document.getElementById('currency-btn');
  var currencyDropdown = document.getElementById('currency-dropdown');
  if (currencyBtn && currencyDropdown) {
    currencyBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = !currencyDropdown.hidden;
      currencyDropdown.hidden = isOpen;
      currencyBtn.setAttribute('aria-expanded', String(!isOpen));
    });
    document.addEventListener('click', function() {
      currencyDropdown.hidden = true;
      currencyBtn.setAttribute('aria-expanded', 'false');
    });
    currencyDropdown.addEventListener('click', function(e) { e.stopPropagation(); });
  }


  /* ── CONTACT FORM submit feedback ── */
  var contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function() {
      var btn = contactForm.querySelector('.cform-submit');
      if (!btn) return;
      btn.disabled = true;
      btn.innerHTML =
        '<svg class="spin-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">' +
          '<path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/>' +
        '</svg> Sending…';
    });
  }


  /* ── ANNOUNCEMENT BAR dismiss ── */
  var promoBar = document.getElementById('promo-bar');
  var promoClose = document.getElementById('promo-bar-close');
  if (promoClose && promoBar) {
    promoClose.addEventListener('click', function() {
      promoBar.style.maxHeight = promoBar.offsetHeight + 'px';
      promoBar.style.overflow = 'hidden';
      promoBar.style.transition = 'max-height .35s ease, opacity .3s ease';
      requestAnimationFrame(function() {
        promoBar.style.maxHeight = '0';
        promoBar.style.opacity = '0';
        promoBar.style.paddingTop = '0';
        promoBar.style.paddingBottom = '0';
      });
      setTimeout(function() { promoBar.style.display = 'none'; }, 400);
      try { sessionStorage.setItem('promo-dismissed', '1'); } catch(e) {}
    });
    try {
      if (sessionStorage.getItem('promo-dismissed') === '1') {
        promoBar.style.display = 'none';
      }
    } catch(e) {}
  }


});
